// Kapito Theme V2

document.addEventListener('DOMContentLoaded', () => {

  // ── Product image gallery ──────────────────────────────
  const mainImg = document.querySelector('.product-gallery__main img');
  const thumbs  = document.querySelectorAll('.product-gallery__thumb');

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (!mainImg) return;
      const src    = thumb.dataset.src;
      const srcset = thumb.dataset.srcset;
      mainImg.src = src;
      if (srcset) mainImg.srcset = srcset;
      mainImg.alt = thumb.dataset.alt || '';
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  if (thumbs.length > 0) thumbs[0].classList.add('active');

  // ── Sidebar accordion ─────────────────────────────────
  document.querySelectorAll('.sidebar-collection-toggle').forEach((btn) => {
    btn.addEventListener('click', () => {
      const parent = btn.closest('.sidebar-collection');
      parent.classList.toggle('open');
    });
  });

  // Auto-open first sidebar section
  const firstSection = document.querySelector('.sidebar-collection');
  if (firstSection) firstSection.classList.add('open');

  // ── Qty buttons ───────────────────────────────────────
  document.querySelectorAll('.qty-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.qty-row').querySelector('.qty-input');
      let v = parseInt(input.value, 10) || 1;
      if (btn.dataset.action === 'minus') v = Math.max(1, v - 1);
      if (btn.dataset.action === 'plus')  v = v + 1;
      input.value = v;
    });
  });

  // ── Sidebar active link (highlight current product) ───
  const path = window.location.pathname;
  document.querySelectorAll('.sidebar-item').forEach((link) => {
    if (link.getAttribute('href') === path) {
      link.classList.add('active');
      const section = link.closest('.sidebar-collection');
      if (section) section.classList.add('open');
    }
  });

});
